export interface InputSearchProps {
  isLoading?: boolean
  placeholderText?: string
  minLength?: number
}

export interface SearchResultsProps extends InputSearchProps {
  withSearch?: boolean
}

export const InputSearchPropsDefaults = {
  isLoading: false,
  placeholderText: 'Search',
  minLength: 3,
} as const satisfies InputSearchProps
